/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (frontend.css in this case)
import './styles/frontend.css';

// import $ from 'jquery';
// global.$ = global.jQuery = $;
// window.$ = window.jQuery = $;

import moment from 'moment';
global.moment = moment;
window.moment = moment;


import 'jquery-ui';
import 'bootstrap';
// import moment from 'moment';
// import 'daterangepicker';
// import 'daterangepicker/daterangepicker.js';
// import drp from 'daterangepicker';
// import drp from 'daterangepicker/daterangepicker.js';
// $.fn.daterangepicker = drp;
/*
const DateRangePicker = require('daterangepicker');

$.fn.daterangepicker = function(options, callback) {
    return this.each(function() {
        const picker = new DateRangePicker(this, options, callback);
        $(this).data('daterangepicker', picker);
    });
};
*/
import DateRangePicker from 'daterangepicker';

function registerDateRangePickerPlugin() {
    if (typeof $.fn.daterangepicker === 'function') {
        return;
    }

    $.fn.daterangepicker = function(options, callback) {
        return this.each(function() {
            const $this = $(this);

            if ($this.data('daterangepicker')) {
                return;
            }

            const picker = new DateRangePicker(this, options, callback);
            $this.data('daterangepicker', picker);
        });
    };
}

registerDateRangePickerPlugin();

// console.log('same jquery?', $ === global.jQuery);
// console.log('plugin export:', drp);
// console.log('fn.daterangepicker:', typeof $.fn.daterangepicker);

// console.log('jQuery:', typeof $);
// console.log('moment:', typeof moment);
// console.log('daterangepicker:', typeof $.fn.daterangepicker);

// import 'jquery';
// import $ from 'jquery';
// window.$ = window.jQuery = $;
// import 'jquery-ui';
// import 'bootstrap';
// import 'moment';
// import 'daterangepicker';
// import './../public/vendor/jquery-3.3.1/jquery.min.js';
// import './../public/vendor/jquery-ui/1.11.4/jquery-ui.js';
// import './../public/vendor/jquery-ui/1.11.4/i18n/datepicker-es.js';
// import './../public/vendor/popper.js@1.16.0/dist/umd/popper.min.js';
// import './../public/vendor/bootstrap/4.4.1/js/bootstrap.min.js';
// import './../public/vendor/moment/moment.min.js';
// import './../public/vendor/moment/locale/es.js';
// import './../public/vendor/daterangepicker/daterangepicker.js';

import './../public/vendor/lightgallery/dist/js/lightgallery-all.min.js';
import './../public/vendor/jquery-cookiebar/jquery.cookieBar.min.js';
import './../public/frontend/js/frontend.js';
import './../public/frontend/js/date-range-picker.js';
